//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
'use client';

import { RadialGradientBG } from '@jouzen/ecom-components';
import { useFeatureGate } from '@statsig/react-bindings';
import { redirect } from 'next/navigation';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import FooterMultivariatePaymentOptions from '@/app/components/MultivariatePaymentOptions/FooterMultivariatePaymentOptions';
import PageLayoutV3 from '@/app/components/PageLayoutV3';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import HeartHealthFeatures from './_components/HeartHealthFeatures';
import HeartHealthHero from './_components/HeartHealthHero';
import HeartHealthIntegrations from './_components/HeartHealthIntegrations';
import HeartHealthJumbotron from './_components/HeartHealthJumbotron';
import HeartHealthPress from './_components/HeartHealthPress';
import HeartHealthTestimonials from './_components/HeartHealthTestimonials';
import heartHealthTestimonialsGradients from './_data/heartHealthTestimonialsGradients';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  const heartHealthPageEnabled = useFeatureGate(
    'heart_health_page_rollout',
  ).value;

  if (!heartHealthPageEnabled) {
    return redirect('/404');
  }

  return (
    <PageLayoutV3
      pageName="Heart Health"
      containerProps={{
        className: 'bg-sandstone-200',
        name: 'heart-health',
        padding: 'none',
      }}
      footerProps={{
        inverseHeaderOnScrollUp: true,
        wrapperClassName: 'bg-brown-500',
      }}
    >
      <InverseHeader exit>
        <HeartHealthHero />
        <RadialGradientBG
          background="sandstone-200"
          className="overflow-hidden"
          gradients={heartHealthTestimonialsGradients}
        >
          <HeartHealthFeatures />
          <HeartHealthJumbotron />
          <HeartHealthTestimonials />
          <HeartHealthIntegrations />
        </RadialGradientBG>
      </InverseHeader>
      <InverseHeader enter>
        <HeartHealthPress />
        <FooterMultivariatePaymentOptions className="bg-brown-500 pb-16" />
      </InverseHeader>
    </PageLayoutV3>
  );
};

export default Content;
